export const VYBES_PUBLISHER_ID = "5365ed27-2f7c-4ee7-aa85-ad1a5a8c3a72";
export const ROCKETS_PUBLISHER_ID = "53f7f80b-b300-4268-bce0-9b3c89f3bc37";
export const YUMI_PUBLISHER_ID = "08c0635f-3956-41e3-905c-272263fb8d22";
export const HONEST_STAGING_PUBLISHER_ID =
	"a8d9f04b-dd6a-4a0b-8fd1-670abd77358f";
export const HONEST_PUBLISHER_ID = "95a21c28-61c4-4d4f-9b4b-c64f556d362b";
export const MERIDIAN_PUBLISHER_ID = "7d069a1c-6969-4a9e-a4f1-4bb754470143";
export const LUMIN_PUBLISHER_ID = "cd57f149-fd10-4cce-80db-193febe6b141";

export const ROCKETS_BRAND_ID = 1988;
